import React, { memo } from "react";
import {
  CategoryStandardProduct,
  StandardProductCategoryProduct,
} from "shared/api/middleware-api-client";
import { REACT_APP_GERS_API_URL } from "shared/config";
import Icon, { IconTypes } from "shared/ui/icon";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";

interface ProductProps {
  categoryProduct: StandardProductCategoryProduct;
  isOptionActive: boolean;
  selectProduct: (product: CategoryStandardProduct) => void;
}

export const StandardProductsProduct = memo(
  ({ categoryProduct, isOptionActive, selectProduct }: ProductProps) => {
    // Check if the product is disabled
    const isDisabled =
      categoryProduct.standardProduct.disabled ||
      categoryProduct.standardProduct.code === "";

    // Return early if isDisabled is true
    if (isDisabled) return null;

    return (
      <button
        className="gg-text-left"
        onClick={() => selectProduct(categoryProduct.standardProduct)}
      >
        <div
          className={concatClassnames(
            "gg-flex gg-items-center gg-justify-center",
            "gg-relative",
            "gg-mb-1.5 gg-rounded-sm gg-border-2 gg-transition gg-duration-300 gg-ease-in-out hover:gg-scale-105 hover:gg-border-dark-blue-400",
            isOptionActive ? "gg-border-dark-blue-400" : "",
          )}
        >
          {categoryProduct.standardProduct.thumbnailId.length !== 0 && (
            <img
              className="gg-h-28 gg-w-28 gg-bg-contain gg-shadow-sm sm:gg-h-24 sm:gg-w-24"
              src={`${REACT_APP_GERS_API_URL}/StandardProducts/download-file/${categoryProduct.standardProduct.thumbnailId}`}
              alt={categoryProduct.standardProduct.mainImageAltText}
            />
          )}

          {isOptionActive && (
            <span
              className={concatClassnames(
                "gg-flex gg-h-6 gg-w-6 gg-bg-green-500",
                "gg-items-center gg-justify-center gg-rounded-full",
                "gg-absolute -gg-right-3 -gg-top-3 gg-h-2",
              )}
            >
              <Icon name={IconTypes.WHITE_CHECK} className="gg-h-2" />
            </span>
          )}
        </div>

        <Text className="gg-w-20 gg-text-xs gg-uppercase">
          {categoryProduct.standardProduct.shortname}
        </Text>
      </button>
    );
  },
);
